import React from "react";

import { useTranslation } from "utils";

import { Button, Icon } from "components";

import { AgronomistCardId } from "pages/app/home/agronomist/agronomistCards";

const ICON_SIZE = 20;

export type AgronomistToolCardProps = {
  id: AgronomistCardId;
  icon: string;
  name: string;
  title: string;
  /** the farm-specific reason to open the tool today */
  hook: string;
  cta: { label: string; onClick: () => void };
  tag?: string;
  recommended: boolean;
};

export const AgronomistToolCard = ({ id, icon, name, title, hook, cta, tag, recommended }: AgronomistToolCardProps) => {
  const { t } = useTranslation("home");
  const badge = recommended ? t("agronomist.startHere") : tag;

  return (
    <article className={`agronomist-card${recommended ? " recommended" : ""}`} data-testid={`agronomist-card-${id}`}>
      <div className="agronomist-card-header">
        <span className="agronomist-card-icon">
          <Icon iconName={icon} size={ICON_SIZE} />
        </span>
        {badge ? (
          <span className={`agronomist-card-badge${recommended ? " start-here" : ""}`} data-testid={`agronomist-card-${id}-badge`}>
            {badge}
          </span>
        ) : null}
      </div>
      <div className="agronomist-card-body">
        <span className="agronomist-card-name">{name}</span>
        <span className="agronomist-card-title" role="heading" aria-level={3}>
          {title}
        </span>
        <span className="agronomist-card-hook" data-testid={`agronomist-card-${id}-hook`}>
          {hook}
        </span>
      </div>
      <Button dataTestId={`agronomist-card-${id}-cta`} type={recommended ? "primary" : "secondary"} className="agronomist-card-cta" onClick={cta.onClick}>
        {cta.label}
      </Button>
    </article>
  );
};
